// extracted by mini-css-extract-plugin
export default {"main":"LoginPage_main__v1qML","btnLogin":"LoginPage_btnLogin__pyzIY"};